import NotificationStore from '../stores/NotificationStore';
import { i18nextInstance } from '../../i18n';
export const ShowNotificationError = (keyMessage) => {
    if (keyMessage) {
        NotificationStore.addNotification({
            message: i18nextInstance.t(`Notifications:${keyMessage}`),
            level: 'warning'
        });
    }
    else {
        NotificationStore.addNotification({
            message: i18nextInstance.t('Notifications:errors.default'),
            level: 'warning'
        });
    }
};
